import FormProductos from '../componentes/FormProductos.vue'
import ListaProductos from '../componentes/ListaProductos.vue'
import FormProductosCompra from '../componentes/FormProductosCompra.vue'
import ListaProductosCompra from '../componentes/ListaProductosCompra.vue'

const routes = [
    ...route('/guardar-producto', FormProductos, {
        Auth: true,
        ///req_admin: true
     }),
     ...route('/lista-productos', ListaProductos, {
       Auth: true,
       //req_admin: true
    }),
    ...route('/guardar-producto-compra', FormProductosCompra, {
        Auth: true,
        ///req_admin: true
     }),
    ...route('/lista-productos-compras', ListaProductosCompra, {
        Auth: true,
        //req_admin: true
     }),
]

function route(path, component = Default, meta = {}) {
	return [{
		path,
		component,
		meta
	}]
}

export default routes